import apiClient from './client';

export const authAPI = {
  // Login
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },

  // Register new user (Admin only)
  register: async (userData) => {
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  },

  // Logout
  // logout: async (refreshToken) => {
  //   const response = await apiClient.post('/auth/logout', { refreshToken });
  //   return response.data;
  // },

  logout: async (refreshToken) => {
    const accessToken = localStorage.getItem('accessToken');
    const response = await apiClient.post(
      '/auth/logout',
      { refreshToken },
      {
        headers: { Authorization: `Bearer ${accessToken}` }
      }
    );
    return response.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  // Save the signed-in user's colour theme
  updateTheme: async (theme) => {
    const response = await apiClient.put('/auth/me/theme', { theme });
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    const response = await apiClient.put('/auth/change-password', {
      currentPassword,
      newPassword,
      confirm_password: confirmPassword
    });
    return response.data;
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    const response = await apiClient.post('/auth/refresh', { refreshToken });
    return response.data;
  }
};

// Get all users (admin)
export const getUsers = async (params = {}) => {
  const response = await apiClient.get('/users', { params });
  return response.data;
};
